const plans = {
  FREE: "FREE",
  PRO: "PRO",
} as const;

export { plans };
